<template>
	<v-card class="px-1 py-2">
		<v-layout align-center>
			<v-flex xs2>
				<img src="/img/bertha/bertha-mini-multicolor-LightMode.svg" style="height: 2rem; vertical-align: middle;" />
			</v-flex>
			<v-flex xs10 text-xs-center>
				<p class="ma-0" style="font-size: .8rem;">AI-generated content should be independently verified.</p>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>

export default {
	name: 'BerthaDisclaimer'
}
</script>
